var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "name",
    transform: "translate(-0.059 -0.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10788",
    "data-name": "Rectangle 10788",
    width: 20,
    height: 20,
    transform: "translate(0.059 0.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33236",
    "data-name": "Group 33236",
    transform: "translate(-104.219 -180.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32844",
    "data-name": "Group 32844",
    transform: "translate(107.5 182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32844-2",
    "data-name": "Group 32844",
    transform: "translate(3.698 4.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17017",
    "data-name": "Path 17017",
    d: "M0,0V1.848",
    transform: "rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17019",
    "data-name": "Path 17019",
    d: "M0,0V1.848",
    transform: "translate(4.313) rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32847",
    "data-name": "Group 32847",
    transform: "translate(3.698 8.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17017-2",
    "data-name": "Path 17017",
    d: "M0,0V1.848",
    transform: "rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17019-2",
    "data-name": "Path 17019",
    d: "M0,0V1.848",
    transform: "translate(4.313) rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32848",
    "data-name": "Group 32848",
    transform: "translate(3.698 12.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17017-3",
    "data-name": "Path 17017",
    d: "M0,0V5.01",
    transform: "rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17019-3",
    "data-name": "Path 17019",
    d: "M0,0V1.848",
    transform: "translate(4.313) rotate(-90)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M443.645,279H437.91a3.817,3.817,0,0,0-3.91,4.161v8.931c0,2.438,1.5,4.161,3.91,4.161h5.734c2.411,0,3.91-1.722,3.91-4.161v-8.931C447.555,280.722,446.055,279,443.645,279Z",
    transform: "translate(-434 -279)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgname);
export default __webpack_public_path__ + "static/media/orgname.5c4de9a8.svg";
export { ForwardRef as ReactComponent };